import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

interface BarcodeProps {
  value: string;
  width?: number;
  height?: number;
  displayValue?: boolean;
  fontSize?: number;
  margin?: number;
  className?: string;
  format?: "CODE128" | "CODE39" | "EAN13" | "EAN8" | "UPC" | "ITF14";
}

const Barcode: React.FC<BarcodeProps> = ({
  value,
  width = 2,
  height = 40,
  displayValue = false,
  fontSize = 12,
  margin = 0,
  className = "",
  format = "CODE128",
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && value) {
      try {
        JsBarcode(canvasRef.current, value, {
          format,
          width,
          height,
          displayValue,
          fontSize,
          margin,
          background: "transparent",
          lineColor: "#000000",
        });
      } catch (error) {
        console.error("Failed to generate barcode:", error);
      }
    }
  }, [value, width, height, displayValue, fontSize, margin, format]);

  return <canvas ref={canvasRef} className={className} style={{ display: "block", maxWidth: "100%", maxHeight: "100%" }} />;
};

export default Barcode;
